import axiosPost from "./axiosPost";

/**
 * Los roles que ESTE merchant puede asignar en el servicio.
 *
 * Distinto de `rolGet`, que devuelve el catalogo completo: este mira lo que el usuario
 * conectado tiene permitido otorgar. Por eso sirve para dos cosas a la vez —llenar el selector
 * de un alta y saber si esa alta es posible—: si vuelve vacio, no hay ningun rol que la
 * persona pueda asignar.
 *
 * `tipo` va TERCERO y vacio por defecto para no tocar a los ocho llamadores que ya existen,
 * que esperan la lista completa. Quien necesita acotar a un tipo de rol lo pide.
 */
export const connectionRolGet = async (servicioCod, credentials, tipo = '') => {
    const body = {
        service: "ConnectionRolGet",
        params: {
            merchantId: credentials.merchantId,
            servicioHooliCod: servicioCod,
            rolTipo: tipo,
        },
    };

    const result = await axiosPost(body, credentials);
    return result;
};
